import { sourcesSymbol, typeSymbol, unAvailabilitySymbol } from '../engine-impl.js';
export class ModelSystemProperties {
    static getSource(propertyValue) {
        if (!propertyValue.parent.value) {
            return;
        }
        if (!propertyValue.parent.value[sourcesSymbol]) {
            propertyValue.parent.value[sourcesSymbol] = {};
        }
        return propertyValue.parent.value[sourcesSymbol][propertyValue.property.name];
    }
    static getSourceFromModel(model, name) {
        if (!model[sourcesSymbol]) {
            model[sourcesSymbol] = {};
        }
        return model[sourcesSymbol][name];
    }
    static addSourceToModel(model, name, source) {
        if (!model[sourcesSymbol]) {
            model[sourcesSymbol] = {};
        }
        model[sourcesSymbol][name] = source;
    }
    static getUnAvailablity(propertyParentTuple) {
        if (!propertyParentTuple.parent.value) {
            return {};
        }
        if (!propertyParentTuple.parent.value[unAvailabilitySymbol]) {
            propertyParentTuple.parent.value[unAvailabilitySymbol] = {};
        }
        return propertyParentTuple.parent.value[unAvailabilitySymbol];
    }
    static addToUnAvailability(propertyValue) {
        if (!propertyValue.parent.value[unAvailabilitySymbol]) {
            propertyValue.parent.value[unAvailabilitySymbol] = {};
        }
        if (!Object.keys(propertyValue.parent.value[unAvailabilitySymbol]).includes(propertyValue.property.name)) {
            propertyValue.parent.value[unAvailabilitySymbol][propertyValue.property.name] = propertyValue.value;
        }
    }
    static removeFromUnAvailability(propertyParentTuple) {
        let value;
        let unAvailable = ModelSystemProperties.getUnAvailablity(propertyParentTuple);
        if (Object.keys(unAvailable).includes(propertyParentTuple.property.name)) {
            value = unAvailable[propertyParentTuple.property.name];
            delete unAvailable[propertyParentTuple.property.name];
        }
        return value;
    }
    static isAvailable(propertyParentTuple) {
        return !Object.keys(ModelSystemProperties.getUnAvailablity(propertyParentTuple)).includes(propertyParentTuple.property.name);
    }
    static getTypeRef(model) {
        return model[typeSymbol];
    }
    static getExplicitType(model) {
        return model._type;
    }
}
//# sourceMappingURL=ModelSystemProperties.js.map